import React, {
  useContext,
  useEffect,
  useState,
  useCallback,
} from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Loader from '../../components/Loader';
import AssignAgentPopUp from '../../components/PopUp/AssignFieldAgent';
import CustomInput from '../../generic/CustomInput/CustomInput';
import CustomBtn from '../../generic/CustomBtn/CustomBtn';
import TableHeaderElement from '../../generic/TableHeaderElement';
import getConfig from '../../config';
import { appStore } from '../../state/app';
import exclamationMarkAlt from '../../assets/image/map/exclamation-mark-alt.svg';
import { sortData } from '../../utils/sort';
import { sendRequest, requestApi } from '../../utils/api-request';
import {
  getAllZones,
  getRemainingZones,
  isProjectOver,
} from '../../utils/helpers';
import DeleteFieldAgent from '../../components/PopUp/DeleteFieldAgent';

const { indexerApi } = getConfig();

const ResendInviteIcon = ({ data, isDisabledAction }) => {
  const translate = useIntl();
  const [resendIcon, setResendIcon] = useState(false);

  const resendInvite = useCallback(async (id) => {
    await requestApi(
      'PUT',
      '/api/dashboard/field-agent/invite',
      {
        field_agent_id: id,
      },
    );
  }, []);

  const handleClick = useCallback(async () => {
    await resendInvite(data.field_agent_id);
    setResendIcon(!resendIcon);
  }, [data.field_agent_id, resendIcon, resendInvite]);

  return (
    <CustomBtn
      label={translate.formatMessage({ id: 'fieldAgents.resendInvite' })}
      customClass="fa-assign-cta"
      iconClass={!resendIcon ? 'icon-reload' : 'icon-check-circle'}
      disabled={isDisabledAction || resendIcon}
      handleClick={handleClick}
    />
  );
};

const ProjectSamplePlotInfo = ({ item }) => {
  const translate = useIntl();
  const [assignAgentPopUp, setAssignAgentPopUp] = useState(false);
  const [deleteAgentPopUp, setDeletAgentPopUp] = useState(false);
  const [simpleZoneInfo, setSimpleZoneInfo] = useState({});
  const [deleteInfo, setDeleteInfo] = useState({});
  const [lastStageEndTime] = useState(
    item.stages?.length
      ? item.stages[item.stages.length - 1].ends_at
      : 0,
  );
  const [isDisabledAction] = useState(isProjectOver(item?.status, lastStageEndTime));
  return (
    <>
      <div className="sample-plot-wrapper">
        <div className="sample-plot-info">
          {item.sampleZones.map((data) => (
            <div key={data.id} className="sample-plot-body">
              <div className="empty-block" />
              <div className="empty-block" />
              <div className="sample-plot-item">
                <div className="sample-plot-zoneName">
                  {data.sampleName}
                  :
                </div>
                <div className="sample-plot-zoneInfo">
                  {data?.field_agent_name ? (
                    <>
                      <div className="cell-text overflow-scroll">
                        {data.field_agent_name}
                      </div>
                      <CustomBtn
                        label={translate.formatMessage({ id: 'fieldAgents.changeFA' })}
                        customClass="fa-assign-cta"
                        iconClass="icon-pencil-alt"
                        disabled={isDisabledAction}
                        handleClick={() => {
                          setSimpleZoneInfo({
                            projects: {
                              [item.project_id]: [
                                {
                                  sample_zone_id: data.id,
                                  sample_zone_name: data.sampleName,
                                },
                              ],
                            },
                          });
                          setAssignAgentPopUp(!assignAgentPopUp);
                        }}
                      />
                      <ResendInviteIcon data={data} isDisabledAction={isDisabledAction} />
                      <CustomBtn
                        customClass="fa-del-cta"
                        iconClass="icon-trash"
                        disabled={isDisabledAction}
                        handleClick={() => {
                          setDeleteInfo({
                            idProject: item.project_id,
                            sample_zone_id: data.id,
                            all: false,

                          });
                          setDeletAgentPopUp(!deleteAgentPopUp);
                        }}
                      />
                      {/* <i */}
                      {/*   className={isDisabledAction ? 'icon-trash-dis' : 'icon-trash'} */}
                      {/*   onClick={() => { */}
                      {/*   }} */}
                      {/* /> */}
                    </>
                  ) : (
                    <CustomBtn
                      label={translate.formatMessage({ id: 'fieldAgents.assignFA' })}
                      customClass="fa-assign-cta"
                      iconClass="icon-add-user"
                      disabled={isDisabledAction}
                      handleClick={() => {
                        setSimpleZoneInfo({
                          projects: {
                            [item.project_id]: [
                              {
                                sample_zone_id: data.id,
                                sample_zone_name: data.sampleName,
                              },
                            ],
                          },
                        });
                        setAssignAgentPopUp(!assignAgentPopUp);
                      }}
                    />
                  )}
                </div>
              </div>
              <div />
            </div>
          ))}
        </div>
      </div>
      <div className="sample-plot-btn-group">
        <CustomBtn
          label={translate.formatMessage({ id: 'fieldAgents.assignAllToFA' })}
          type="button"
          customClass="btn__fa-assign"
          disabled={isDisabledAction}
          handleClick={() => {
            const resultGetAllZones = getAllZones(item);
            setSimpleZoneInfo(resultGetAllZones);
            setAssignAgentPopUp(!assignAgentPopUp);
          }}
        />
        <CustomBtn
          label={translate.formatMessage({ id: 'fieldAgents.assignRemainingSamplePlots' })}
          type="button"
          customClass="btn__fa-assign"
          disabled={isDisabledAction}
          handleClick={() => {
            const resultGetRemainingZones = getRemainingZones(item);
            setSimpleZoneInfo(resultGetRemainingZones);
            setAssignAgentPopUp(!assignAgentPopUp);
          }}
        />
        <CustomBtn
          label={translate.formatMessage({ id: 'popUp.fieldAgents.delete.all' })}
          type="button"
          customClass="btn__fa-assign remove"
          disabled={isDisabledAction || !item.sampleZones.some((i) => i.field_agent_name)}
          handleClick={() => {
            setDeleteInfo({
              idProject: item.project_id,
              sample_zone_id: '',
              all: true,
            });
            setDeletAgentPopUp(!deleteAgentPopUp);
          }}
        />
      </div>

      {assignAgentPopUp ? (
        <AssignAgentPopUp
          showPopUp={assignAgentPopUp}
          setShowPopUp={setAssignAgentPopUp}
          simpleZoneInfo={simpleZoneInfo}
        />
      ) : null}
      {deleteAgentPopUp ? (
        <DeleteFieldAgent
          showPopUp={deleteAgentPopUp}
          setShowPopUp={setDeletAgentPopUp}
          deleteInfo={deleteInfo}
        />
      ) : null}
    </>
  );
};

const FieldAgentsTableBodyItem = ({ item }) => {
  const [hideElement, setHideElement] = useState(false);

  return (
    <div className={`table-body-wrapper ${hideElement ? 'border-open' : 'border-closed'}`}>
      <div className="table-body">
        <div className="table-body-item project overflow-scroll">{item.name}</div>
        <div className="table-body-item location overflow-scroll">
          <i className="icon-marker" />
          {item.region}
        </div>
        <div className="table-body-item">
          <ProjectAssignStatus item={item} />
        </div>
        <div
          className="table-body-item cta-more"
          onClick={() => { setHideElement(!hideElement); }}
        >
          <i className={`icon-left-arrow ${hideElement ? 'Up' : 'Down'}`} />
        </div>
      </div>
      {hideElement ? <ProjectSamplePlotInfo item={item} /> : null}
    </div>
  );
};

const FieldAgentsTableBody = ({ queryResulAllProjects }) => (
  <>
    {queryResulAllProjects?.map((item) => (
      <FieldAgentsTableBodyItem item={item} key={item.project_id} />
    ))}
  </>
);

const ProjectAssignStatus = ({ item }) => {
  const assignStatus = item.sampleZones;
  const assignFilter = assignStatus.filter((i) => i.assign);
  let iconSamplePlotStatus = 'icon-info-circle';
  if (!assignFilter.length) {
    iconSamplePlotStatus = 'icon-closing-cross-circle';
  }
  if (assignFilter.length === assignStatus.length) {
    iconSamplePlotStatus = 'icon-check-circle';
  }
  return <i className={iconSamplePlotStatus} />;
};

const FieldAgents = () => {
  const { state } = useContext(appStore);
  const { account, app } = state;
  const translate = useIntl();
  const [loadingData, setLoading] = useState(true);
  const [allProjects, setAllProjects] = useState([]);
  const [queryResulAllProjects, setQueryResulAllProjects] = useState([]);
  const [noSearchData, setNoSearchData] = useState();
  const [allProjectsSearch, setAllProjectsSearch] = useState('');

  useEffect(async () => {
    if (account) {
      const bodyReq = {
        query: {
          bool: {
            must: [
              {
                match: {
                  'signer_id.keyword': account.accountId,
                },
              },
              {
                exists: {
                  field: 'sampleZones',
                },
              },
            ],
          },
        },
        from: 0,
        size: 100,
      };
      const { result } = await sendRequest(indexerApi, 'POST', JSON.stringify(bodyReq), false);
      const sampleZoneFromMongo = await requestApi('GET', '/api/dashboard/sample-zone/list');
      const updProjects = result?.hits?.hits?.length ? result?.hits?.hits : [];
      const newUpdProject = [];
      // eslint-disable-next-line no-unused-vars
      for (const [i, hit] of Object.entries(updProjects)) {
        const updSource = { ...hit._source };
        for (const [j, sz] of Object.entries(hit._source.sampleZones)) {
          const target = sampleZoneFromMongo?.find((szM) => (szM.project_id === hit._id && szM.sample_zone_id === sz.id && szM?.field_agent_id));
          updSource.sampleZones[j].assign = !!target;
          updSource.sampleZones[j].field_agent_name = target ? target.field_agent_name : '';
          updSource.sampleZones[j].field_agent_id = target ? target.field_agent_id : '';
        }
        newUpdProject.push(updSource);
      }
      setAllProjects(newUpdProject);
      setLoading(false);
    }
  }, [account, app.allFa]);

  useEffect(() => {
    const filteredObjAllProjects = allProjects.filter((obj) => {
      const valueSearch = allProjectsSearch.toLowerCase().trim();
      const { name = '', region = '' } = obj;
      return name.toLowerCase().includes(valueSearch) || region.toLowerCase().includes(valueSearch);
    });
    setQueryResulAllProjects(filteredObjAllProjects);
    setNoSearchData(filteredObjAllProjects);
  }, [allProjects, allProjectsSearch]);

  if (loadingData) {
    return (
      <div className="field-agent__loader">
        <Loader />
      </div>
    );
  }

  const projectDataSort = (sortName, sortAscDesc) => {
    const resSort = sortData(allProjects, sortName, sortAscDesc);
    setQueryResulAllProjects([...resSort]);
  };

  return (
    <div className="field-agent">
      <div className="field-agent__header">
        <h2 className="field-agent__header-title">
          {translate.formatMessage({ id: 'fieldAgents.assignments' })}
        </h2>
        {!!allProjects?.length && (
          <div className="field-agent__search">
            <CustomInput
              type="text"
              placeholder={translate.formatMessage({ id: 'fieldAgents.searchProjectsPlaceholder' })}
              customClass="input-search"
              iconClass="icon-search"
              change={(event) => setAllProjectsSearch(event.target.value)}
            />
          </div>
        )}
      </div>
      {allProjects?.length ? (
        <div className="field-agent__table">
          {noSearchData?.length === 0 ? (
            <div className="noSearchData">{translate.formatMessage({ id: 'fieldAgents.noResultsFound' })}</div>
          ) : (
            <>
              <div className="table-header">
                <div className="table-header-item">
                  <TableHeaderElement
                    params={{
                      projectDataSort,
                      sortName: 'name',
                      value: translate.formatMessage({ id: 'fieldAgents.project' }),
                    }}
                  />
                </div>
                <div className="table-header-item">
                  <TableHeaderElement
                    params={{
                      projectDataSort,
                      sortName: 'region',
                      value: translate.formatMessage({ id: 'fieldAgents.location' }),
                    }}
                  />
                </div>
                <div className="table-header-item">
                  <TableHeaderElement
                    params={{
                      value: translate.formatMessage({ id: 'fieldAgents.samplePlotsStatus' }),
                    }}
                  />
                </div>
                <div className="table-header-item cta-more">
                  <TableHeaderElement
                    params={{
                      value: translate.formatMessage({ id: 'fieldAgents.more' }),
                    }}
                  />
                </div>
              </div>
              <FieldAgentsTableBody
                queryResulAllProjects={queryResulAllProjects}
              />
            </>
          )}
        </div>
      ) : (
        <div className="my-field-agent__empty">
          <div className="my-field-agent__exclamation">
            <img src={exclamationMarkAlt} alt="Exclamation" />
          </div>
          <FormattedMessage
            id="fieldAgents.emptyList"
            values={{
              div: (...chunks) => <div className="empty-text">{chunks}</div>,
              bold: (chunks) => <b>{chunks}</b>,
              br: <br />,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default FieldAgents;
